import './App.css';
import { HashRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import RegisterAdmin from './Components/RegisterAdmin';
import B2BLogin from './Components/B2BLogin';
import FlightSearch from './Components/FlightSearch';
import FlightCard from './Components/FlightCard';
import Account from './Components/Account';
import BankDetails from './Components/BankDetails';
import SolidTicket from './Components/SolidTicket';
import GroupQuery from './Components/GroupQuery';
import RefundTicket from './Components/RefundTicket';
import TemporaryCredit from './Components/TempCredit';
import ChangePassword from './Components/ChangePassword';
import AirPaxCalendar from './Components/AirPaxCalendar';
import AppBar from './Components/AppBar';
import OnlineRecharge from './Components/OnlineRecharge';
import TicketBooking from './Components/TicketBooking';
import TicketPdf from './Components/TicketPdf';
import RazorpayCheckout from './Components/razorpayCheckout';
import StripePayment from './Components/StripePayment';
import ForgotPassword from './Components/ForgotPassword';
import VerifyCodeAgency from './Components/VerifyCodeAgency';
import ResetPasswordAgency from './Components/ResetPasswordAgency';
import Footer from "./Components/Footer"; // new import at the top of App.js
import Profile from './Components/Profile';


function App() {
  return (
    <Router>
      <Routes>
        {/* Conditionally render the AppBar only for routes other than '/' */}
        <Route
          path="/"
          element={<B2BLogin />}
        />
        <Route path="/registerAdmin" element={<RegisterAdmin />} />
         <Route path="/forgotPassword" element={<ForgotPassword/>} />
         <Route path="/verify-code-admin" element={<VerifyCodeAgency />} />
         <Route path="/admin-reset-password" element={<ResetPasswordAgency/>}/>
        <Route
          path="*"
          element={<AppBarWithRoutes />}
        />
      </Routes>
    </Router>
  );
}

// // This component is used to wrap all the routes that need AppBar
// function AppBarWithRoutes() {
//   const location = useLocation();
//   const showAppBar = location.pathname !== '/'; // Do not show AppBar on the login page

//   // Prevent the user from navigating back to the login page
//   if (window.history && window.history.pushState) {
//     window.history.pushState(null, null, window.location.href);
//     window.onpopstate = function () {
//       window.history.pushState(null, null, window.location.href);
//     };
//   }

//   return (
//     <div className="">
//       {showAppBar && <AppBar />}
      
//       <Routes>

//         <Route path="/flightSearch" element={<FlightSearch />} />
//         <Route path="/flightCard" element={<FlightCard />} />
//         <Route path="/account" element={<Account />} />
//         <Route path="/bank_Details" element={<BankDetails />} />
//         <Route path="/solidticket" element={<SolidTicket />} />
//         <Route path="/group_query" element={<GroupQuery />} />
//         <Route path="/refundticket" element={<RefundTicket />} />
//         <Route path="/TempCreditRep" element={<TemporaryCredit />} />
//         <Route path="/change-password" element={<ChangePassword />} />
//         <Route path="/airpaxcalendar" element={<AirPaxCalendar />} />
//         <Route path="/recharge" element={<StripePayment/>} />
//         <Route path="/bookticket" element={<TicketBooking />} />
//         <Route path="/ticket-pdf" element={<TicketPdf />} />
//         <Route path="/razorpay" element={<RazorpayCheckout/>} />
//       </Routes>
//     </div>
//   );
// }



function AppBarWithRoutes() {
  const location = useLocation();
  const showAppBar = location.pathname !== '/';

  if (window.history && window.history.pushState) {
    window.history.pushState(null, null, window.location.href);
    window.onpopstate = function () {
      window.history.pushState(null, null, window.location.href);
    };
  }
return (
  <div className="app-container">
    {showAppBar && <AppBar />}

    <div className="routes-container">
      <Routes>
        <Route path="/flightSearch" element={<FlightSearch />} />
        <Route path="/flightCard" element={<FlightCard />} />
        <Route path="/account" element={<Account />} />
        <Route path="/bank_Details" element={<BankDetails />} />
        <Route path="/solidticket" element={<SolidTicket />} />
        <Route path="/group_query" element={<GroupQuery />} />
        <Route path="/refundticket" element={<RefundTicket />} />
        <Route path="/TempCreditRep" element={<TemporaryCredit />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/airpaxcalendar" element={<AirPaxCalendar />} />
        <Route path="/recharge" element={<StripePayment/>} />
        <Route path="/bookticket" element={<TicketBooking />} />
        <Route path="/ticket-pdf" element={<TicketPdf />} />
        <Route path="/razorpay" element={<RazorpayCheckout/>} />
         <Route path="/profile" element={<Profile/>} />
      </Routes>
    </div>

    {showAppBar && <Footer />}
  </div>
);

}

export default App;
